import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { origamiCardMotion } from './motion';
import { origamiChromeTone } from './palette';

export const origamiTheme: FlowThemeDefinition = {
  id: 'origami',
  label: 'Origami',
  description: 'Fold a paper crane for every question and string them into a garland across a papercraft valley.',
  category: 'daylight',
  chromeTone: origamiChromeTone,
  swatch: 'linear-gradient(160deg, #94C6E8 0%, #FCE4D6 48%, #9DD2A0 72%, #F2857A 100%)',
  cardGlass: 'default',
  cardMotion: origamiCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createOrigamiScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
